import i18next from 'i18next';
import { all, takeEvery, call, fork, take, put } from 'redux-saga/effects';
import { requestPuppy, isApiError } from '@wix/da-http-client';
import { putErrorNotification } from '../../../utils/saga';
import { uploadAttachment, uploadAttachmentImmediately, uploadAttachmentProgress, uploadAttachmentSuccess, uploadAttachmentFailure, cancelAttachmentUpload, removeAttachment } from '../actions';
import { createUploadChannel } from './base';
import { uploadQueueWatcher } from './queue';
function* createAttachmentUploadChannel(file, deviationId, attachmentType = 'pcp') {
    const url = 'deviation/attachments/add';
    const formData = new FormData();
    formData.append('attachment_file', file);
    formData.append('deviationid', `${deviationId}`);
    formData.append('type', attachmentType);
    return yield call(createUploadChannel, url, formData, 'attachment');
}
function* uploadAttachmentHandler(action) {
    const { file, uploadId, parentDeviationId, onSuccess, onFailure } = action.payload;
    const channel = yield call(createAttachmentUploadChannel, file, parentDeviationId, 'pcp');
    // If a cancel action for this file id is fired we close the channel
    yield fork(function*() {
        yield take((action)=>action.type === cancelAttachmentUpload.toString() && action.payload.uploadId === uploadId);
        channel.close();
    });
    while(true){
        const { progress = 0, error, success, response } = yield take(channel);
        if (error) {
            yield put(uploadAttachmentFailure(uploadId, error));
            if (onFailure) {
                yield call(onFailure, {
                    uploadId
                }, error);
            }
            return;
        }
        if (success) {
            const { fileId, deviationId } = response;
            yield put(uploadAttachmentSuccess(uploadId, fileId, deviationId, file));
            if (onSuccess) {
                yield call(onSuccess, {
                    uploadId,
                    fileId: fileId,
                    deviationId: deviationId,
                    file
                });
            }
            return;
        }
        yield put(uploadAttachmentProgress(uploadId, progress));
    }
}
function* removeAttachmentHandler({ payload }) {
    const { fileId, deviationId, type, onSuccess } = payload;
    const data = {
        fileid: fileId,
        deviationid: deviationId,
        type
    };
    const result = yield call(requestPuppy, {
        method: 'post',
        url: 'deviation/attachments/remove',
        data
    }, undefined);
    if (!result || isApiError(result) || !result.success) {
        yield putErrorNotification(i18next.t('somethingWentWrong'));
        return;
    }
    onSuccess();
}
export default function* saga() {
    yield all([
        takeEvery(uploadAttachmentImmediately, uploadAttachmentHandler),
        uploadQueueWatcher('attachment', [
            uploadAttachment,
            uploadAttachmentSuccess,
            uploadAttachmentFailure
        ], uploadAttachmentImmediately),
        takeEvery(removeAttachment, removeAttachmentHandler)
    ]);
}

//# sourceMappingURL=attachments.js.map